import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import changePasswordReducer from './changePassword/data/reducer';
import changePasswordSaga, {
  initSaga as changePasswordInitSaga,
} from './changePassword/data/sagas';
import loginActivityReducer from './loginActivity/data/reducer';
import loginActivitySaga, {
  initSaga as loginActivitySagaInitSaga,
} from './loginActivity/data/sagas';
import multiOrgSettingsReducer from './multiOrganizationSettings/data/reducer';
import multiOrgSettingsSaga from './multiOrganizationSettings/data/sagas';
import twoFactorAuthReducer from './twoFactorAuthentication/data/reducer';
import twoFactorAuthSaga from './twoFactorAuthentication/data/sagas';
import userInfoReducer from './userInfo/data/reducer';
import userInfoSaga, {
  initSaga as userInfoInitSaga,
} from './userInfo/data/sagas';

const initSaga = function* () {
  yield all([
    changePasswordInitSaga(),
    userInfoInitSaga(),
    loginActivitySagaInitSaga(),
  ]);
};

const reducer = combineReducers({
  changePassword: changePasswordReducer,
  twoFactorAuth: twoFactorAuthReducer,
  userInfo: userInfoReducer,
  loginActivity: loginActivityReducer,
  multiOrgSettings: multiOrgSettingsReducer,
});

const saga = function* () {
  yield all([
    changePasswordSaga(),
    twoFactorAuthSaga(),
    userInfoSaga(),
    loginActivitySaga(),
    multiOrgSettingsSaga(),
  ]);
};

export { initSaga, reducer, saga };
